import { apiClient } from '@/libs/api'

export type FetchMonthlyTourReportQuery = {
  tenantKey: string
  monthlyTourReportId: number
}

export const fetchMonthlyTourReport = async (
  { tenantKey, monthlyTourReportId }: FetchMonthlyTourReportQuery,
  signal?: AbortSignal
) => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .monthly_tour_reports._id(monthlyTourReportId)
    .$get({
      config: { signal }
    })
  return data
}
